import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  nombre: null,
  UserNamer: null,
  Aduana: null,
  Transportista: null,
  Scac: null,
  email: "",
  Logeado:false
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    addUser: (state, action) => {
      const { nombre, UserNamer, email } = action.payload;
      state.nombre = nombre;
      state.UserNamer = UserNamer;
      state.email = email;
    },
    changeEmail: (state, action) => {
      state.email = action.payload;
    },
    changeLogeado: (state, action) => {
      state.Logeado = true;
    }
  }
});

export const { addUser, changeEmail,changeLogeado } = userSlice.actions;
export default userSlice.reducer;
